import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-auxilia',
  templateUrl: './spinner-auxilia.component.html',
  styleUrls: ['./spinner-auxilia.component.scss']
})
export class SpinnerAuxiliaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
